module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.simple) ? _c('ul', {
    class: _vm.simpleWrapClasses,
    style: (_vm.styles)
  }, [_c('li', {
    class: _vm.prevClasses,
    attrs: {
      "title": ('上一页')
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    class: _vm.simplePagerClasses,
    attrs: {
      "title": _vm.currentPage + '/' + _vm.allPages
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.currentPage
    },
    on: {
      "keydown": _vm.keyDown,
      "keyup": _vm.keyUp,
      "change": _vm.keyUp
    }
  }), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v("\n    " + _vm._s(_vm.allPages) + "\n\n  ")]), _vm._v(" "), _c('li', {
    class: _vm.nextClasses,
    attrs: {
      "title": ('下一页')
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._m(1)])]) : _c('ul', {
    class: _vm.wrapClasses,
    style: (_vm.styles)
  }, [_c('li', {
    class: _vm.prevClasses,
    attrs: {
      "title": ('上一页')
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    class: _vm.firstPageClasses,
    attrs: {
      "title": "1"
    },
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  }, [_c('a', [_vm._v("1")])]), _vm._v(" "), (_vm.currentPage - 3 > 1) ? _c('li', {
    class: [_vm.prefixCls + '-item-jump-prev'],
    attrs: {
      "title": ('i.page.prev5')
    },
    on: {
      "click": _vm.fastPrev
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.currentPage - 2 > 1) ? _c('li', {
    class: [_vm.prefixCls + '-item'],
    attrs: {
      "title": _vm.currentPage - 2
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage - 2)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage - 2))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage - 1 > 1) ? _c('li', {
    class: [_vm.prefixCls + '-item'],
    attrs: {
      "title": _vm.currentPage - 1
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage - 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage != 1 && _vm.currentPage != _vm.allPages) ? _c('li', {
    class: [_vm.prefixCls + '-item', _vm.prefixCls + '-item-active'],
    attrs: {
      "title": _vm.currentPage
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 1 < _vm.allPages) ? _c('li', {
    class: [_vm.prefixCls + '-item'],
    attrs: {
      "title": _vm.currentPage + 1
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage + 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 2 < _vm.allPages) ? _c('li', {
    class: [_vm.prefixCls + '-item'],
    attrs: {
      "title": _vm.currentPage + 2
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage + 2)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage + 2))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 3 < _vm.allPages) ? _c('li', {
    class: [_vm.prefixCls + '-item-jump-next'],
    attrs: {
      "title": ('i.page.next5')
    },
    on: {
      "click": _vm.fastNext
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.allPages > 1) ? _c('li', {
    class: _vm.lastPageClasses,
    attrs: {
      "title": _vm.allPages
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.allPages)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.allPages))])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: _vm.nextClasses,
    attrs: {
      "title": ('下一页')
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._m(5)]), _vm._v(" "), (_vm.showTotal) ? _c('span', {
    class: [_vm.prefixCls + '-total']
  }, [_vm._t("default", [_vm._v(_vm._s(('共')) + " " + _vm._s(_vm.total) + " "), (_vm.total <= 1) ? [_vm._v(_vm._s(('条')))] : [_vm._v(_vm._s(('条')))]])], 2) : _vm._e(), _vm._v(" "), _vm._t("totalpsn"), _vm._v(" "), _c('Options', {
    attrs: {
      "show-sizer": _vm.showSizer,
      "page-size": _vm.currentPageSize,
      "page-size-opts": _vm.pageSizeOpts,
      "placement": _vm.placement,
      "show-elevator": _vm.showElevator,
      "_current": _vm.currentPage,
      "current": _vm.currentPage,
      "all-pages": _vm.allPages,
      "is-small": _vm.isSmall
    },
    on: {
      "on-size": _vm.onSize,
      "on-page": _vm.onPage
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd1100c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page.vue
// module id = 1413
// module chunks = 107